
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(fd|g0|ku|lf)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
